// The app's look, picked per person: garage (light, side menu), night (dark, icon rail), office (light, top menu).
// Applied as <html data-theme="…">; cached on the device so the right look shows before the profile loads.
export type Theme = 'garage' | 'night' | 'office';
export const THEMES: Theme[] = ['garage', 'night', 'office'];
const KEY = 'vp-theme';
const dark = () => window.matchMedia?.('(prefers-color-scheme: dark)').matches;

let chosen: Theme | null = null;
function paint() {
  const t = chosen ?? (dark() ? 'night' : 'garage');
  document.documentElement.dataset.theme = t;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', t === 'office' ? '#ffffff' : t === 'night' ? '#0b0c0e' : '#17191d');
}

/** null = follow the device (dark mode → night) */
export function applyTheme(t: Theme | null | undefined) {
  chosen = t && THEMES.includes(t) ? t : null;
  try { if (chosen) localStorage.setItem(KEY, chosen); else localStorage.removeItem(KEY); } catch { /* private mode */ }
  paint();
}

export function currentTheme(): Theme {
  return (document.documentElement.dataset.theme as Theme) || 'garage';
}

/** Called once at start-up */
export function initTheme() {
  let saved: string | null = null;
  try { saved = localStorage.getItem(KEY); } catch { /* ignore */ }
  chosen = THEMES.includes(saved as Theme) ? saved as Theme : null;
  paint();
  window.matchMedia?.('(prefers-color-scheme: dark)').addEventListener?.('change', () => { if (!chosen) paint(); });
}
